// test2359
(2359 && 0);
